import { TasksContainer } from 'components/tasks/TasksContainer';
import React from 'react';
import { useParams } from 'react-router-dom';
import { OrderTabs } from 'store/order/orderNavigation/orderNavigationSlice';
import { UUID } from 'types/shared/UUID';
import { useSetOrderNavigationTab } from 'utilities/hooks/useSetOrderNavigationTab';

export const TasksPage: React.FC = () => {
  const { taskId } = useParams<{ taskId?: UUID }>();
  useSetOrderNavigationTab({ tab: OrderTabs.Tasks });
  return <TasksContainer highlightedTaskId={taskId} defaultTab={'All'} showFiltersByDefault />;
};
